export default "__VITE_ASSET__CBMo2QAN__"